import moment from 'moment'

export default {
  props: {
    id: {
      type: String
    },
    title: {
      type: String,
      default: 'Фильтры'
    },
    filter: {
      type: Object,
      default () {
        return {}
      }
    },
    isEnabled: {
      type: Boolean
    }
  },
  data () {
    return {
      newFilter: {},
      filters: {},
      isOpen: true,
      isToggleExpandedFilters: false,
      isDontEmit: false
    }
  },
  methods: {
    onFilter (filterChangeDto) {
      this.newFilter[filterChangeDto.component.id] = filterChangeDto.value
      this.$emit('update:is-enabled', !filterChangeDto.isDefaultValue)
      if (!this.isDontEmit) {
        this.$emit('change', this.newFilter)
      }
    },
    onFilterReady (filterChangeDto) {
      this.filters[filterChangeDto.component.id] = filterChangeDto.component
      this.newFilter[filterChangeDto.component.id] = filterChangeDto.value

      if (Date.parse(filterChangeDto.value)) {
        this.newFilter[filterChangeDto.component.id] = moment(filterChangeDto.value).format('YYYY-MM-DD')
      }

      this.$emit('update:is-enabled', !filterChangeDto.isDefaultValue)
    },
    async clearAll (options = { exceptFilterKeys: [] }) {
      this.isDontEmit = true
      const keys = Object.keys(this.filters).filter(key => !options.exceptFilterKeys.includes(key))
      for (let filter of keys) {
        await this.filters[filter].clear()
      }
      this.$nextTick(() => {
        this.isDontEmit = false
        this.$emit('update:filter', this.newFilter)
        this.$emit('change', this.newFilter)
        this.$emit('clearAll')
      })
    }
  },
  mounted () {
    this.$emit('update:filter', this.newFilter)
  }
}
